import {
    Locale,
    GameName,
    gameSettings,
    DefaultLocale,
} from "inbox-contentful";

const gameName: GameName = "squadbusters";

export const config = {
    gameName,
    gameResolution: {
        x: 740,
        y: 480,
    },
    locales: (gameSettings[gameName]?.enabledLocales ?? [DefaultLocale]).filter(
        (x) => x !== "zh-hans",
    ) as Locale[],
    tabs: ["news", "community"],
    isFullScreen: false,
};
